import { Component, ElementRef, ViewChild } from '@angular/core';
import { CrmService } from 'src/home/crm/services/crm.service';
import { HomeService } from 'src/home/home.service';
import { CsvData } from 'src/models/CsvData.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-bulk-create-fees',
  templateUrl: './bulk-create-fees.component.html',
  styleUrls: ['./bulk-create-fees.component.css'],
})
export class BulkCreateFeesComponent {
  @ViewChild('csvInput') csvInput!: ElementRef<HTMLInputElement>;
  isLoading: boolean = false;
  selectedFile?: File;

  constructor(private homeService: HomeService, private crmService: CrmService) { }

  onFileSelected(event: Event) {
    const element = event.target as HTMLInputElement;
    const file = element.files?.[0];
    if (file) {
      this.selectedFile = file;
    }
  }

  triggerFileInput() {
    this.csvInput.nativeElement.click();
  }

  uploadFile() {
    if (this.selectedFile) {
      this.isLoading = true;
      this.crmService.bulkCreateFees(this.selectedFile).subscribe({
        next: (response: CsvData) => {
          this.isLoading = false;
          this.handleResponse(response);
        },
        error: (error) => {
          this.isLoading = false;
          Swal.fire({
            title: 'Error',
            icon: 'error',
            text: 'Ha habido un problema al procesar tu solicitud. Por favor, inténtalo de nuevo.',
            confirmButtonText: 'OK',
            confirmButtonColor: '#F95A14',
          });
          console.error('Detalles del error:', error.message);
        },
      });
    }
  }

  private handleResponse(response: CsvData) {
    if (response.errors.length) {
      console.error('Errores detallados:', response.errors.join('\n'));
      Swal.fire({
        title: 'Proceso completado con errores',
        icon: 'warning',
        text: `${response.data.length} tarifas fueron procesadas pero hubo problemas con los datos. Por favor revisa la consola para más detalles.`,
        confirmButtonText: 'OK',
        confirmButtonColor: '#F95A14',
      });
    } else {
      Swal.fire({
        title: 'Éxito',
        icon: 'success',
        text: `${response.data.length} tarifas han sido creadas con éxito.`,
        confirmButtonText: 'OK',
        confirmButtonColor: '#F95A14',
      });
    }
  }
}
